module.exports = __webpack_public_path__ + "static/media/galerija_2019 (41).d3d5783d.jpg";